export default __webpack_public_path__ + "static/media/avatar.60b75acd.png";